//miliseconds
const DEBOUNCE_TIME = 3000;

const keyMapper = {
  occupants: {
    name: 'full_name',
    homePhone: 'home_phone',
    workPhone: 'work_phone',
    cellPhone: 'cell_phone',
    phoneNumber: 'phone',
    ssn: 'ssn',
  },

  moveIn: {
    moveInDate: 'expected_move_in',
    selectedFloorPlan: 'floor_plan_id',
    selectedUnitNumber: 'unit_number',
  },

  vehicles: {
    modal: 'make_model',
    licensePlate: 'license_plate',

  },

  employments: {
    employerName: 'employer',
    phoneNumber: 'phone',
    supervisorName: 'supervisor',
    monthlyIncome: 'salary',
    durationOfEmployment:'duration',
  },

  emergencyContacts: {
    phoneNumber: 'phone'
  },

  currentResidency: {
    name: 'landlord_name',
    number: 'landlord_phone',
    email: 'landlord_email',
    current: 'current'
  }

}

const ErrorMapper = {
  occupants: {
    name: 'name_error',
    homePhone: 'phone_error',
    workPhone: 'phone_error',
    cellPhone: 'phone_error',
    dob: 'too_young',
    ssn: 'ssn_error',
  },

  moveIn: {
    moveInDate: 'movein_error',
  },

  vehicles: {
    modal: "vehicle_mm_error",
    color: "vehicle_color_error",
    licensePlate: "vehicle_license_error",
    state: "vehicle_license_state_error"
  },

  pets: {
    name: "pet_name_error",
    breed: "pet_breed_error",
    type: "pet_type_error",
    weight: "pet_weight_error"
  },

  employments: {
    durationOfEmployment:'employment_duration_error',
    employerName: 'employment_name_error',
    phoneNumber: 'employment_num_error',
    email: "email_error",
    monthlyIncome: 'salary_error',
    supervisorName: 'employment_super_error',
    monthlyIncome: 'salary_error',

    address: "address_error",
    city: "city_error",
    state: "state_error",
    zip: "zip_error",
  },

  emergencyContacts: {
    name: "contact_name_error",
    phoneNumber: "contact_phone_error",
    email: "email_error",
    relationship: "contact_relation_error"
  },

  currentResidency: {
    email: 'landlord_email_error',
    address: "address_error",
    city: "city_error",
    state: "state_error",
    zip: "zip_error",

  }
}

const tabs = [
  { id: 'occupants', display: 'Occupants' },
  { id: 'moveInInformation', display: 'Move In Information' },
  { id: 'pets', display: 'Pets' },
  { id: 'vehicles', display: 'Vehicles' },
  { id: 'currentResidency', display: 'Current Residency' },
  { id: 'employmentInformations', display: 'Employment Information' },
  { id: 'emergencyContacts', display: 'Emergency Contacts' },
  { id: 'uploadedDoc', display: 'Upload Documents' },
  { id: 'review', display: 'Review' },
]

const tabsArray = [
  'occupants',
  'moveInInformation',
  'pets',
  'vehicles',
  'currentResidency',
  'employmentInformations',
  'emergencyContacts',
  'uploadedDoc',
  'review',
]

export {
  DEBOUNCE_TIME,
  tabs,
  tabsArray,
  ErrorMapper,
  keyMapper,
}
